<template>
    <div class="slider clearfix">
        <div class="wrapper clearfix">
            <div class="col-xs-120 no-padding sliks_conteiner">
                <div class="big-arrow-left">
                    <img src="/static/img/general/big-arrow-left.png">
                </div>
                <div class="sliks" style="overflow: hidden; float: left; width: 90%">
                  <div class="col-md-27 col-sm-60 no-padding"  v-if="!articles || articles.indexOf(row.link) !== -1" v-for="(row, key) in similar" :key="key">
                    <div class="block" >
                      <router-link :to="'/' + row.link" class="similar-link" :style="'background: url(' + row.img + ') 0 0 no-repeat;'"><!--<img src="{{row.img}}">--></router-link>
                      <h3><router-link :to="row.link">{{row.title}}</router-link></h3>
                      <p>{{row.short_desc}}<router-link class="show_more_link" :to="row.link">подробнее</router-link></p>
                    </div>
                  </div>
                </div>
                <div class="big-arrow-right">
                    <img src="/static/img/general/big-arrow-right.png">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'slick-carousel'
export default {
  name: 'Articles',
  props: ['city', 'user', 'auth', 'articles'],
  data () {
    return {
      similar: []
    }
  },
  created () {
    axios.get('https://crm.v-avtoservice.com/list/site-articles-list').then(response => {
      this.similar = response.data
      setTimeout(() => {
        var slick = $('.sliks').slick({
          infinite: true,
          dots: false,
          rows: 0,
          slidesToShow: this.articles ? this.articles.length : 4,
          slidesToScroll: 1,
          аccessibility: false
        })
        $('.slick-next').hide()
        $('.slick-prev').hide()
        $('.big-arrow-left').click(function () {
          slick.slick('slickPrev')
        })
        $('.big-arrow-right').click(function () {
          slick.slick('slickNext')
        })
      }, 500)
    })
  },
  mounted () {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/Articles.vue